<div
  class="cards__momentos__especiais"
  *ngIf="quantidadeCards > 0 && !estaNaLP"
>
  <div
    class="cards"
    (click)="abrirPopup(experiencia)"
    *ngFor="let experiencia of experiencias"
  >
    <div class="header">
      <img
        class="img__card"
        [src]="experiencia.imagemSrc"
        alt="Imagem do card"
      />
    </div>
    <div class="footer">
      <p class="titulo">{{ experiencia.nome }}</p>
      <p class="data">Outubro/24</p>
    </div>
  </div>
</div>

<div class="loader__desktop" *ngIf="this.quantidadeCards == 0">
  <ngx-skeleton-loader
    *ngIf="this.quantidadeCards == 0"
    count="6"
    [theme]="{
      'border-radius': '24px',
      width: '217px',
      height: '295px'
    }"
  ></ngx-skeleton-loader>
</div>

<lovers-popup
  [exibir]="exibirPopupImg"
  (onClose)="fecharPopup()"
  tamanho="pequeno"
  *ngIf="width > 480 && experiencia?.imagemSrc2"
>
  <img
    class="img__popup"
    [src]="experiencia?.imagemSrc2"
    alt="Imagem descritiva do popup"
  />
</lovers-popup>

<lovers-popup
  [exibir]="exibirPopupImg"
  (onClose)="fecharPopup()"
  tamanho="pequeno"
  *ngIf="width <= 480 && experiencia?.imagemSrc3"
>
  <img
    class="img__popup"
    [src]="experiencia?.imagemSrc3"
    alt="Imagem descritiva do popup"
  />
</lovers-popup>
